// Enable native browser scroll restoration for standard navigation
// Collection pages with AJAX pagination will use a hybrid approach
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'auto';
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):not([type='radio']):enabled, input[type='radio']:checked, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;   
    if (event.target.name === 'plus' && previousValue == '1') {
      event.target.parentNode.querySelector('button[name="minus"]').disabled = false;
    } else if (event.target.name === 'minus' && previousValue == '2') {
      event.target.disabled = true;
    }
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    event.target.closest('tr.cart-item').classList.add('cart__items--disabled');
    event.target.focus();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  // This is to support autofill for our country custom dropdown
  Shopify.addListener(this.countryEl, 'change', () => {
    let countryDefaultBtn = this.countryEl.nextElementSibling.querySelector('[data-button-text]')
    let countryDefaultInput = this.countryEl.nextElementSibling.querySelector('input[name="address[country]"]');

    // Set selected option on custom selector when autofilled
    if(countryDefaultBtn && countryDefaultInput){
      countryDefaultInput.value = this.countryEl.value;
      countryDefaultBtn.textContent = this.countryEl.value;
    }
  });

  // This is to support autofill for our province/country custom dropdown
  Shopify.addListener(this.provinceEl, 'change', () => {
    let countyDefaultBtn = this.provinceEl.parentElement.querySelector('[data-button-text]')
    let countyDefaultInput = this.provinceEl.parentElement.querySelector('input[name="address[province]"]');
    // Set first option as default
    if(countyDefaultBtn && countyDefaultInput){
      countyDefaultInput.value = this.provinceEl.value;
      countyDefaultBtn.textContent = this.provinceEl.value;
    }
  });

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt && opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    let ulList = this.provinceEl.parentElement.querySelector('province-list');

    this.clearOptions(this.provinceEl);

    this.clearOptions(ulList);

    if (provinces && provinces.length == 0 || (this.countryEl.value != "United States" && this.countryEl.value != "Australia")) {
      this.provinceContainer.style.display = 'none';
      this.provinceEl.style.display = 'none';
      this.provinceEl.previousElementSibling.value = '';
    } else {

      for (const [index, element] of provinces.entries()) {

        var opt = document.createElement('option');
        var liElement = document.createElement('li');

        // Set attributes and content for list item
        liElement.setAttribute('data-option-type', 'county');
        liElement.setAttribute('data-option', '');
        liElement.setAttribute('data-value', element[0]);
        liElement.setAttribute('data-title', element[0]);
        liElement.textContent = element[1];

        // Append list item to the unordered list
        ulList.appendChild(liElement);

        if(index === 0){
          let countyDefaultBtn = this.provinceContainer.querySelector('[data-button-text]')
          let countyDefaultInput = this.provinceContainer.querySelector('input[name="address[province]"]');

          // Set first option as default
          if(countyDefaultBtn && countyDefaultInput){
            countyDefaultInput.value = element[1];
            countyDefaultBtn.textContent = element[1];
          }
        }

        opt.value = element[0];
        opt.innerHTML = element[1];
        this.provinceEl.appendChild(opt);
      }
      
      this.provinceEl.style.display = '';
      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
    if (isIOS) {
      const setViewportHeight = () => {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      };

      setViewportHeight();

      window.addEventListener('resize', setViewportHeight);
      window.addEventListener('orientationchange', setViewportHeight);
    }

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    elementToFocus?.setAttribute('aria-expanded', false);
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);

    if (
      this.mainDetailsToggle.classList.contains('mobile-facets__disclosure') ||
      !this.mainDetailsToggle.hasAttribute('open')
    ) {
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
          const headerDrawer = this.closest('header-drawer');
          headerDrawer?.header?.classList.remove('menu-open');
        }

        const openParent = detailsElement.closest('details[open]');
        if (openParent) {
          trapFocus(openParent, detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.header-wrapper');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (this.poster) {
      this.poster.addEventListener('click', this.loadContent.bind(this));
    }

    this.observer = new IntersectionObserver(this.lazyLoad.bind(this), {
      rootMargin: '200px',
      threshold: 0.1
    });
  }

  connectedCallback() {
    const video = this.querySelector('video');
    if (video) {
      this.observer.observe(video);
    }
  }

  lazyLoad(entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        const video = entry.target;
        if (video.readyState === HTMLMediaElement.HAVE_NOTHING) {
          video.load();
        }
        if (video.hasAttribute('autoplay') && video.paused) {
          video.play().catch(() => {});
        }
        this.observer.unobserve(video);
      }
    }
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.paginationContainer = document.createElement('div');
    this.paginationContainer.className = 'pagination-dots';
    this.appendChild(this.paginationContainer);

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.addPaginationDots();
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;

    }

    if (this.currentPage != previousPage) {

      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if(this.prevButton){
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if(this.nextButton){
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;

    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  addPaginationDots() {
    this.paginationContainer.innerHTML = ''; // Clear existing dots

    for (let i = 0; i < this.totalPages; i++) {
      const dot = document.createElement('span');
      dot.className = 'pagination-dot';
      dot.dataset.page = i + 1;
      dot.addEventListener('click', this.onDotClick.bind(this));
      this.paginationContainer.appendChild(dot);
    }
  }

  onDotClick(event) {
    const page = parseInt(event.currentTarget.dataset.page);
    this.slideToPage(page);
  }

  slideToPage(page) {
    if (page < 1 || page > this.totalPages) return;

    const scrollPosition = (page - 1) * this.sliderItemOffset;
    this.slider.scrollTo({ left: scrollPosition });
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VerticalSliderComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = false;
    this.paginationContainer = document.createElement('div');
    this.paginationContainer.className = 'pagination-dots';

    // Initialize a debounced version of initPages for efficient execution
    this.debouncedInitPages = this.debounce(this.initPages, 250);
  }

  connectedCallback() {
    this.slider = this.querySelector('[id^="Vertical-Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) {
      console.error("Essential elements Slider or Next Button are missing.");
      return;
    }

    this.debouncedInitPages();
    const resizeObserver = new ResizeObserver(entries => this.debouncedInitPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update);
    this.prevButton.addEventListener('click', this.onButtonClick);
    this.nextButton.addEventListener('click', this.onButtonClick);

    this.appendChild(this.paginationContainer);
  }

  debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    }
  }

  initPages = () => {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientHeight > 0);
    if (this.sliderItemsToShow.length < 2) return;
    
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    
    
   this.slidesPerPage = Math.floor((this.slider.offsetHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset);
    
    
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.addPaginationDots();
    this.update();
  }

  update = () => {

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    
    if (this.currentPage != previousPage) {
      
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;
  }

  isSlideVisible = (element, offset = 0) => {
    const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
    

    return (element.offsetTop + element.clientHeight) <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
  }

  slideToPage = (page) => {
    
    if (page < 1 || page > this.totalPages) return;

    const scrollPosition = (page - 1) * this.sliderItemOffset;
    this.slider.scrollTo({ top: scrollPosition });
  }

  onButtonClick = (event) => {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollTop + (step * this.sliderItemOffset) : this.slider.scrollTop - (step * this.sliderItemOffset);

    window.requestAnimationFrame(() => {
      this.slider.scrollTo({
        top: this.slideScrollPosition,
        behavior: 'smooth'
      });
    });
  }
}

customElements.define('vertical-slider-component', VerticalSliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.checkVariantOptionsOnLoad();
    this.addEventListener('change', this.onVariantChange);
    this.form = document.querySelector('.product-form form');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // Run global OOS pass first (resets all, then disables fully-OOS options)
    this.checkVariantOptionsOnLoad();
    // Then layer on cross-option filtering (only adds disabled, never re-enables)
    this.updateVariantStatuses();

    // Pass this.currentVariant to updateDataLayerEvent only if it is defined
    if (this.currentVariant) {
      this.updateDataLayerEvent(this.currentVariant);
    }

    // Check if this.currentVariant is undefined or has a price <= 0
    if (!this.currentVariant || this.currentVariant.price <= 0) {  
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateDataLayerEvent(){
    // Ensure window.dataLayer is defined.
    window.dataLayer = window.dataLayer || [];
    // colourCode is not part of the variant, we get it as a metafield from the product instead.
    // product metafield: wmsconnect.colourCode
    window.dataLayer.push({
      event: "product.interact.manual.click.variantSelected",
      variantID: [
          this.currentVariant.option2,
          this.dataset.colourCode,
          this.currentVariant.option1,
          this.currentVariant.id
      ]
    });
  }

  checkVariantOptionsOnLoad() {
    /* Initialize data structures */
    const option1Data = {};
    const option2Data = {};
    let outOfStockOptions = [];
    /* Process option1Data and option2Data to disable out-of-stock options */
    let totalOptions = 0;
    let disabledOptions = 0;
    const addToCartButton = this.form?.querySelector('button[type="submit"]') || document.querySelector('product-form button[type="submit"]');
    const addButtonText = this.form?.querySelector('[name="add"] > span') || document.querySelector('[name="add"] > span');

    const optionRadios = Array.from(this.querySelectorAll('input[type="radio"]'));
    const optionFieldsets = Array.from(this.querySelectorAll('fieldset'));
    optionRadios.forEach((radioInput) => {
      radioInput.classList.remove('disabled');
      radioInput.removeAttribute('disabled');
      radioInput.removeAttribute('aria-disabled');
    });

    /* Single pass over window.varArray to gather data */
    window.varArray && window.varArray.forEach(variant => {
      const { variantOption1, variantOption2, variantInvQty } = variant;

      /* Initialize option1Data and option2Data objects */
      if (!option1Data[variantOption1]) {
        option1Data[variantOption1] = { total: 0, outOfStock: 0 };
      }
      if (!option2Data[variantOption2]) {
        option2Data[variantOption2] = { total: 0, outOfStock: 0 };
      }

      /* Update totals */
      option1Data[variantOption1].total += 1;
      option2Data[variantOption2].total += 1;

      /* Check if variant is out of stock, has a 0 price or it should show as OOS(force OOS for Austrialia and ROW) */
      if (Number(variantInvQty) <= 0 || variant.variantPrice <= 0 || variant.variantOOS == 'true') {
        outOfStockOptions.push(variant);
        option1Data[variantOption1].outOfStock += 1;
        option2Data[variantOption2].outOfStock += 1;
      }
    });

    /* Process option1Data and option2Data to disable out-of-stock options */
    [option1Data, option2Data].forEach((optionData, optionIndex) => {
      const optionFieldset = optionFieldsets[optionIndex];
      if (!optionFieldset) return;

      for (const [optionValue, data] of Object.entries(optionData)) {
        totalOptions++;  // Increment total options count
        if (data.total === data.outOfStock) {
          /* Disable this option radio button */
          const matchingRadios = Array.from(optionFieldset.querySelectorAll('input[type="radio"]')).filter((radioInput) => radioInput.value === optionValue);
          matchingRadios.forEach((radioInput) => {
            radioInput.setAttribute('disabled', 'disabled');
            radioInput.setAttribute('aria-disabled', 'true');
            radioInput.classList.add('disabled');
          });

          if (matchingRadios.length) disabledOptions++;  // Increment disabled options count
        }
      }
    });
    /* Check if all options have been disabled */
    if (totalOptions > 0 && totalOptions === disabledOptions) {
      // All option radios are disabled, disable ATC
      addToCartButton?.classList.add('disabled');
      addToCartButton?.setAttribute('disabled', 'disabled');
      if (addButtonText) addButtonText.textContent = window.variantStrings.soldOut;    
    } else {
      addToCartButton?.classList.remove('disabled');
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const productFormId = productForm.getAttribute('id');
      const input = productForm.querySelector('input[name="id"]');
      const wishlistBtn = productForm.querySelector('.swymcs-wishlist-button--pdp');
      const wishlistMediaBtns = document.querySelectorAll(
        `.swymcs-wishlist-button--media[form="${productFormId}"]`
      );
      const addToWishlistMessage = window.accessibilityStrings.addProductToWishlistSelected;
      const title = addToWishlistMessage.replace("product_title",`${this.currentVariant.name},`);

      if (wishlistBtn) {
        wishlistBtn.setAttribute("title", title);
        wishlistBtn.setAttribute("aria-disabled", "false");
        wishlistBtn.dataset.epi = this.currentVariant.id;
        wishlistBtn.dataset.variantTitle = this.currentVariant.title;
      }
      wishlistMediaBtns.forEach((wishlistMediaBtn) => {
        wishlistMediaBtn.setAttribute("title", title);
        wishlistMediaBtn.setAttribute("aria-disabled", "false");
        wishlistMediaBtn.dataset.epi = this.currentVariant.id;
        wishlistMediaBtn.dataset.variantTitle = this.currentVariant.title;
      });
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /**
   * This method updates the statuses of variant options.
   */
  updateVariantStatuses() {
    if (document.querySelector('.gift-card-product')) return;
    // Cache the DOM queries to avoid querying multiple times.
    const checkedItems = [...this.querySelectorAll(':checked')];
    const inputWrappers = [...this.querySelectorAll('fieldset.field__container')];

    if (checkedItems.length === 0) return;

    // Filter the variants based on the checked options.
    const selectedOptionOneVariants = this.filterVariantsByOption(checkedItems[0].value, 1);
    const selectedOptionTwoVariants = this.filterVariantsByOption(checkedItems.map(item => item.value), 2);

    // Iterate over the input wrappers to update the status of each variant option.
    inputWrappers.forEach((option, index) => {
      const FIRST_OPTION = 0;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];

      // If it's the first option, handle it with a specific logic.
      if (index === FIRST_OPTION) {
        this.handleFirstOption(optionInputs, inputWrappers, index, selectedOptionTwoVariants);
      } else {
        // Otherwise, handle the other options.
        this.handleSubsequentOptions(optionInputs, inputWrappers, index, selectedOptionOneVariants);
      }
    });
  }

  /**
   * Filters the variant data based on the specified option values and option number.
   * @param {Array|string} optionValues - Values to filter by.
   * @param {number} optionNumber - The option number.
   * @returns {Array} Filtered variant data.
   */
  filterVariantsByOption(optionValues, optionNumber) {
    // Ensure optionValues is an array.
    if (!Array.isArray(optionValues)) {
      optionValues = [optionValues];
    }

    // Filter and return the variants.
    return this.variantData.filter(variant => optionValues.includes(variant[`option${optionNumber}`]));
  }

  /**
   * Handles the logic for the first option.
   */
  handleFirstOption(optionInputs, inputWrappers, index, selectedOptionTwoVariants) {
    if (selectedOptionTwoVariants.length) {
      const nextChecked = inputWrappers[index + 1]?.querySelector(':checked');
      if (!nextChecked) return;
      const nextOptionSelectedValue = nextChecked.value;
      const availableOptions = selectedOptionTwoVariants
        .filter(variant => this.isVariantEffectivelyAvailable(variant) && variant[`option${index + 2}`] === nextOptionSelectedValue)
        .map(variantOption => variantOption[`option${index + 1}`]);

      // Set the availability of the input options.
      this.setInputAvailability(optionInputs, availableOptions);
    }
  }

  /**
   * Handles the logic for options other than the first.
   */
  handleSubsequentOptions(optionInputs, inputWrappers, index, selectedOptionOneVariants) {
    if (!inputWrappers[index - 1].querySelector(':checked')) {
      return;
    }

    const previousOptionSelectedValue = inputWrappers[index - 1].querySelector(':checked').value;
    const availableOptions = selectedOptionOneVariants
      .filter(variant => this.isVariantEffectivelyAvailable(variant) && variant[`option${index}`] === previousOptionSelectedValue)
      .map(variantOption => variantOption[`option${index + 1}`]);

    // Set the availability of the input options.
    this.setInputAvailability(optionInputs, availableOptions);
  }

  /**
   * Sets the availability of the given list of options based on a list of available options.
   * @param {Array} listOfOptions - List of options to update.
   * @param {Array} listOfAvailableOptions - List of available options.
   */
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    // Convert the list of available options to a Set for faster lookups.
    const availableOptionsSet = new Set(listOfAvailableOptions);

    // Update the inner text of each option based on its availability.
    listOfOptions.forEach((input) => {
      const inputValue = input.getAttribute('value');

      if (availableOptionsSet.has(inputValue)) {
        input.innerText = inputValue;
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', inputValue);
      }
    });
  }

  // Checks if a variant is effectively available, considering both
  // Shopify's native availability and custom varArray OOS logic
  isVariantEffectivelyAvailable(variant) {
    if (!variant.available) return false;
    if (window.varArray) {
      const varData = window.varArray.find(v => String(v.variantID) === String(variant.id));
      if (varData) {
        if (Number(varData.variantInvQty) <= 0) return false;
        if (Number(varData.variantPrice) <= 0) return false;
        if (varData.variantOOS == 'true') return false;
      }
    }
    return true;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const complimusSource = html.getElementById(`Complimus-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const complimusDestination = document.getElementById(`Complimus-${this.dataset.section}`);
        const fromPrice = document.querySelector(".from-price");

        if (source && destination){
           destination.innerHTML = source.innerHTML;
           destination.classList.remove("hidden");
           fromPrice?.classList.add("hidden");
        }

        if (inventorySource && inventoryDestination) {
          inventoryDestination.innerHTML = inventorySource.innerHTML;
          inventoryDestination.classList.remove('hidden');
        }

        if (complimusSource && complimusDestination) {
          complimusDestination.innerHTML = complimusSource.innerHTML;
        }

        if(this.currentVariant.price <= 0){
          inventoryDestination.classList.add('hidden');
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        // Sync sticky bar price with the updated PDP price
        const stickyPriceEl = document.querySelector('[data-sticky-price]');
        const mainPriceEl = price.querySelector('.price');
        if (stickyPriceEl && mainPriceEl) {
          stickyPriceEl.innerHTML = mainPriceEl.outerHTML;
        }

        let notAvailableVariant = !this.currentVariant || !this.currentVariant.available || this.currentVariant.price <= 0;

        this.toggleAddButton(notAvailableVariant, window.variantStrings.soldOut);
      });
  }
 
  isValidInput(input, type) {
    let regexPattern = /^(?!^\s)[\wÀ-ÿ-\u0390-\u03CE\u3040-\u309F. ]+$/;
    input.value = input.value.replace(/^\s+/, ''); // Remove leading spaces

    switch (type) {
      case 'name':
        regexPattern = /^(?!^\s)[\wÀ-ÿ-\u0390-\u03CE\u3040-\u309F. ]+$/;
        break;
      case 'email':
        regexPattern = /^([a-zA-Z0-9_\-.+]+)@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.)|(([a-zA-Z0-9-]+.)+))([a-zA-Z]{2,}|[0-9]{1,3})(]?)$/;
        break;
      case 'message':
        regexPattern = /^[a-zA-Z0-9 ~`!@#$%^&*()_+?:"{}[\];’éàèùâêîôûçëïüÉÀÈÙÂÊÎÔÛÇËÏÜÄäÖöÜüß\s,;:.\-]+$/;
        break;
      case 'from':
        regexPattern = /^(?!^\s)[\wÀ-ÿ-\u0390-\u03CE\u3040-\u309F. ]+$/;
        break;
      case 'date':
        regexPattern = '';
        break;
    }

    let isValid;
    if (input.hasAttribute('required')) {
      isValid = regexPattern.test(input.value);
   
    }

    if (!input.hasAttribute('required')) {
      return true;
    } else if (input.value.length === 0) {
      return false;
    } else {
      return isValid;
    }
  }

  areAllInputsValid() {

    if (
      this.isValidInput(this.inputTypeName, 'name') &&
      this.isValidInput(this.inputTypeEmail, 'email') &&
      this.isValidInput(this.inputTypeFrom, 'from') &&
      this.isValidInput(this.inputTypeMessage, 'message') &&
      this.isValidInput(this.inputTypeDate, 'date')
    ) {
      return true;
    } else {
      return false;
    }
  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const productFormId = productForm.getAttribute('id');
    const wishlistBtn = productForm.querySelector('.swymcs-wishlist-button');
    const wishlistMediaBtns = document.querySelectorAll(
      `.swymcs-wishlist-button--media[form="${productFormId}"]`
    );

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      wishlistBtn?.setAttribute('disabled', 'disabled');
      wishlistMediaBtns.forEach((wishlistMediaBtn) => wishlistMediaBtn.setAttribute('disabled', 'disabled'));
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      wishlistBtn?.removeAttribute('disabled');
      wishlistMediaBtns.forEach((wishlistMediaBtn) => wishlistMediaBtn.removeAttribute('disabled'));
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addToWishlistButton = button.querySelector('[name="add-wishlist"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (addToWishlistButton) addToWishlistButton.setAttribute('disabled', 'disabled');
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // Trigger change when loaded
    this.onVariantChange()
  }

  // Overwrite updateOptions method to check for unavailable variants
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    
    this.options = fieldsets.map((fieldset, index) => {
      const radio = Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked);
      const errorMessageWrapper = this.form.parentElement.querySelector('.product-form__error-message-wrapper');

      if (radio) {
        errorMessageWrapper.setAttribute('hidden', true);
        fieldset.nextElementSibling?.classList.contains('option-error-message') && fieldset.nextElementSibling.classList.add('hidden');

        // ✅ Focus next unselected fieldset
        // COMMENTED OUT AS PER DISCUSSION - SHOULD BE FIXED IN THE FUTURE
        // const nextFieldset = fieldsets[index + 1];
        // if (nextFieldset) {
        //   const isNextSelected = Array.from(nextFieldset.querySelectorAll('input')).some(r => r.checked);
        //   if (!isNextSelected) {
        //     const nextInput = nextFieldset.querySelector('input[type="radio"]');
        //     if (nextInput) nextInput.focus();
        //   }
        // }

        return radio.value;
      } else {
        throw new Error('No radio button checked for a fieldset');
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    //  Only add disabled states here — never re-enable.
    //  checkVariantOptionsOnLoad() already reset all states and applied global OOS;
    //  this method layers on cross-option unavailability on top of that
    listOfOptions.forEach((input) => {
      if (!listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.add('disabled');
        input.setAttribute('disabled', 'disabled');
        input.setAttribute('aria-disabled', 'true');
      }
    });

  }
}

customElements.define('variant-radios', VariantRadios);


  // Added for accessibility purposes so that external links can give a hint to the user that they will open in a new window.
  function addTitleToExternalLinks() {
    if (!window.accessibilityStrings || !window.accessibilityStrings.openInNewWindow) {
      console.error("accessibilityStrings.openInNewWindow is not defined.");
      return;
    }
  
    const links = document.querySelectorAll('a[target="_blank"]');
  
    links.forEach(link => {
      link.setAttribute('title', window.accessibilityStrings.openInNewWindow);
    });
  }

  addTitleToExternalLinks();
